import { render, staticRenderFns } from "./bnps_project.vue?vue&type=template&id=0fb1bd59&scoped=true&"
import script from "./bnps_project.vue?vue&type=script&lang=js&"
export * from "./bnps_project.vue?vue&type=script&lang=js&"
import style0 from "./bnps_project.vue?vue&type=style&index=0&id=0fb1bd59&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb1bd59",
  null
  
)

export default component.exports